import { getAxiosClient } from './index';

export const emailInquire = (inquirer_name: string, company_name: string, email: string, inquiries: string, type: string) => {
    const restClient = getAxiosClient();
    return restClient.post('/inquire', { inquirer_name, company_name, email, inquiries, type });
};
